import { useState, useEffect, useContext } from 'react';
import { Translate } from '@/components';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import MuiBottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import SearchIcon from '@mui/icons-material/SearchOutlined';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { APP_ROUTES } from '@/config/constants';
import { useAnalytics } from '@/hooks/useAnalytics';
import { GenericTrackTypes } from '@/types/genericTrackTypes';
import styles from './BottomNavigation.styles';
import AuthenticationContext from '@/context/AuthenticationContext';
import { openLoginDrawerVar } from '@/graphql/state';

const options = [
  {
    label: 'Home',
    icon: <HomeOutlinedIcon />,
    route: APP_ROUTES.home,
  },
  // {
  //   label: 'Upcoming',
  //   icon: <CalendarTodayOutlinedIcon />,
  //   route: APP_ROUTES.upcoming,
  // },
  {
    label: 'Explore',
    icon: <SearchIcon />,
    route: APP_ROUTES.explore,
  },
  {
    label: 'Saved',
    icon: <StarOutlineIcon />,
    route: APP_ROUTES.saved,
  },
  {
    label: 'Account',
    icon: <AccountCircleOutlinedIcon />,
    route: APP_ROUTES.account,
  },
];

export const BottomNavigation: React.FC = () => {
  const { isAuthenticated } = useContext(
    AuthenticationContext,
  );
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { track } = useAnalytics();
  const [value, setValue] = useState(() =>
    options.findIndex(o => o.route === pathname),
  );
  useEffect(() => {
    setValue(options.findIndex(o => o.route === `/${pathname.split('/')[1]}`));
  }, [pathname]);

  return (
    <footer className={styles.marginTop}>
      <MuiBottomNavigation
        showLabels
        className={styles.container}
        value={value}
        onChange={(event, newValue) => {
          if (isAuthenticated) {
            setValue(newValue);
            navigate(options[newValue].route);
            track({
              action: GenericTrackTypes.BUTTON_PRESSED,
              category: 'bottom_navigation',
              label: options[newValue].label,
            });
          } else {
            openLoginDrawerVar(true);
          }
        }}
        component="nav"
        aria-label="Main Navigation"
      >
        {options.map(({ label, icon }) => (
          <BottomNavigationAction
            key={label}
            className={styles.action}
            label={<Translate>{label}</Translate>}
            icon={icon}
            data-testid={`${label.toLowerCase()}Button`}
          />
        ))}
      </MuiBottomNavigation>
    </footer>
  );
};
